import { Service } from '../config'
import { LoginService } from '../loginConfig'

class AuthenticationService extends LoginService {
  path = 'account'

  async login(params: any) {
    const httpResponse = await this.httpClient.post(
      this.path + `/login`,
      params
    )
    return httpResponse
  }

  async authenticate(params: any) {
    const httpResponse = await this.httpClient.post(
      `${this.path}/authenticate`,
      params
    )
    return httpResponse
  }

  async resendEmail(params: any) {
    const httpResponse = await this.httpClient.post(
      `${this.path}/resendcode`,
      params
    )
    return httpResponse
  }

  async logout() {
    const httpResponse = await this.httpClient.post(this.path + `/logout`)
    return httpResponse
  }

  async forgotPassword(params: any) {
    const httpResponse = await this.httpClient.post(
      this.path + `/esquecisenha`,
      params
    )
    return httpResponse
  }

  async newPassword(params: any) {
    const httpResponse = await this.httpClient.put(
      this.path + `/resetarsenha`,
      params
    )
    return httpResponse
  }

  async changeCpf(params: any) {
    const httpResponse = await this.httpClient.post(
      this.path + `/confirmarAlteracaoCpf `,
      params
    )
    return httpResponse
  }

  async changeEmail(params: any) {
    const httpResponse = await this.httpClient.post(
      this.path + `/confirmarAlteracaoEmail `,
      params
    )
    return httpResponse
  }

  async createCustomer(params: any) {
    const httpResponse = await this.httpClient.post(
      this.path + '/cadastrarusuario',
      params
    )
    return httpResponse
  }

  async updateCustomer(params: any) {
    const httpResponse = await this.httpClient.put(
      this.path + '/atualizarusuario',
      params
    )
    return httpResponse
  }

  async getPermission(params?: any) {
    const httpResponse = await this.httpClient.get(
      this.path + '/obterlistafuncoespermissoes',
      params
    )
    return httpResponse
  }

  async newProfile(params: any) {
    const httpResponse = await this.httpClient.post(
      this.path + '/cadastrarfuncao',
      params
    )
    return httpResponse
  }

  async updateProfile(params: any) {
    const httpResponse = await this.httpClient.put(
      this.path + '/editarfuncao',
      params
    )
    return httpResponse
  }

  async approve(params: any) {
    const httpResponse = await this.httpClient.put(
      `${this.path}/approve`,
      params
    )
    return httpResponse
  }
}

class AuthenticationDataService extends Service {
  async customerData(id: string) {
    const httpResponse = await this.httpClient.get(`usuario?Id=${id}`)
    return httpResponse
  }
}

export const authenticationService = new AuthenticationService()

export const authenticationDataService = new AuthenticationDataService()
